import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/tmp/build_e118ec62/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/tmp/build_e118ec62/layouts/login.vue").then(m => m.default || m))
}